// extracted by mini-css-extract-plugin
module.exports = {"CloudinaryImage":"CloudinaryImage___2WFA_","BrandOverlay":"BrandOverlay___1CwsV","ImageWrap":"ImageWrap___1Mdqr","loading":"loading___3kVuQ"};